import CPIcon from './cp_icon.png';
import FCIcon from './fc_icon.png';
import FWIcon from './fw_icon.png';
import FWACrocIcon from './fwacroc_icon.png';
import FWAPenguinIcon from './fwapenguin_icon.png';
import FWMIcon from './fwm_icon.png';
import JIGIcon from './jig_icon.png';
import MCIcon from './mc_icon.png';
import MEMIcon from './mem_icon.png';
import FallbackIcon from './fallback_icon.png';
import FCUIcon from './fcu_icon.png';
import PlaceholderIcon from './placeholder_icon.png';
import SDIcon from './sd_icon.png';
import SJIcon from './sj_icon.png';
import SMCIcon from './smc_icon.png';
import SNAPIcon from './snap_icon.png';
import SpellTestIcon from './spell_test_primary.png';
import SSIcon from './ss_icon.png';
import STIcon from './st_icon.png';
import StubmunkIcon from './stubmunk_icon.png';
import STWIcon from './stw_icon.png';
import SWIcon from './sw_icon.png';
import VideoIcon from './video_icon.png';
// import VocabIcon from './vocab_icon.png';
import WAMIcon from './wam_icon.png';
import WBIcon from './wb_icon.png';
import WBCIcon from './wbc_icon.png';
import WBDIcon from './wbd_icon.png';
import WBWIcon from './wbw_icon.png';
import WFIcon from './wf_icon.png';
import WSIcon from './ws_icon.png';

// Phonics
import LDIcon from './ld_icon.png';
import LHIcon from './lh_icon.png';
import PHIcon from './ph_icon.png';
import PWPIcon from './pwp_icon.png';
import SBTNIcon from './sbtn_icon.png';
import SCIcon from './sc_icon.png';
import SHIcon from './sh_icon.png';
import WHIcon from './wh_icon.png';
import SLLPIcon from './sllp_icon.png';
import SLPLIcon from './slpl_icon.png';
import SLPWIcon from './slpw_icon.png';
import SLWPIcon from './slwp_icon.png';

// Handwriting
import HWIcon from './hw_icon.png';

// Decodables
import DECIcon from './dec_icon.png';
import SIOIcon from './sio_icon.png';

// Arcade ones that we only 'need' for morph/showcase
import BSIcon from './bs_icon.png';
import PenpenIcon from './penpen_icon.png';
import SBIcon from './sb_icon.png';
import TKIcon from './tk_icon.png';
import WMorphIcon from './wmorph_icon.png';

const icons = {
  cp: CPIcon,
  fc: FCIcon,
  fcu: FCUIcon,
  fw: FWIcon,
  fwacroc: FWACrocIcon,
  fwapenguin: FWAPenguinIcon,
  fwm: FWMIcon,
  instructional: VideoIcon,
  jig: JIGIcon,
  lesson: SDIcon,
  mc: MCIcon,
  mem: MEMIcon,
  sd: SDIcon,
  sj: SJIcon,
  smc: SMCIcon,
  snap: SNAPIcon,
  spell_test: SpellTestIcon,
  ss: SSIcon,
  st: STIcon,
  stw: STWIcon,
  sw: SWIcon,
  tc: StubmunkIcon, // TODO can this one be deleted?
  tupperware: SDIcon,
  wam: WAMIcon,
  wb: WBIcon,
  wbcard: WBCIcon,
  wbdesert: WBDIcon,
  wbwaterfall: WBWIcon,
  wf: WFIcon,
  ws: WSIcon,

  // Phonics
  ld: LDIcon,
  lh: LHIcon,
  ph: PHIcon,
  pwp: PWPIcon,
  sbtn: SBTNIcon,
  sc: SCIcon,
  sh: SHIcon,
  wh: WHIcon,
  sllp: SLLPIcon,
  slpl: SLPLIcon,
  slpw: SLPWIcon,
  slwp: SLWPIcon,

  // Handwriting
  hw: HWIcon,

  // Decodables
  dec: DECIcon,
  sio: SIOIcon,

  // Arcade ones that we only 'need' for morph/showcase
  bs: BSIcon,
  penpen: PenpenIcon,
  sb: SBIcon,
  tk: TKIcon,
  awm: WMorphIcon
};

// This was designed as the one central source of truth for all icons in Next

// 29 July 2021
// It turns out we now have another copy in client/sx/entry/my_words/MyWordsImages.re
// and apparently another version somewhere in /tx

// The plan is to clean all this up and create the one source of truth again.

const getIcon = (name) => {
  if (name) {
    const iconName = name.toLowerCase();
    if (icons[iconName]) {
      return icons[iconName];
    }
  }
  return FallbackIcon;
};

export default {
  getIcon,
  PlaceholderIcon
};
